// Facet WP
// Using JQuery because FacetWP emits JQuery events only. JavaScript can't listen to JQuery events via addEventListener()
// https://stackoverflow.com/questions/40915156/listen-for-jquery-event-with-vanilla-js
/* global FWP */
import ExpandToggle from "@threespot/expand-toggle";

if (window.jQuery) {
  // Event is triggered after a user interacts with a facet or pagination control.
  // https://facetwp.com/documentation/developers/javascript/facetwp-loaded/
  $(document).on('facetwp-loaded', function() {
    removeBoardChair();
    replacePagerIcons();
  });
}

// Removes the board chair member on all subsequent pages after the first
function removeBoardChair() {
  const params = new URLSearchParams(window.location.search);
  let boardChair = document.getElementById('BoardChair');
  let currentPage = params.get('_paged');

  if (!boardChair) {
    return false;
  }

  if (!currentPage) {
    return false;
  }

  if (parseInt(currentPage, 10) > 1) {
    boardChair.parentElement.removeChild(boardChair);
  }
}

// FacetWP defaults to < and > for previous and next buttons
// Replace FacetWP Pager navigation chevron glyphs with custom SVG icons
function replacePagerIcons() {
  $('.facetwp-page.prev').html(`
    <svg width="8" height="12" viewBox="0 0 256 512" transform="rotate(180)" xmlns="http://www.w3.org/2000/svg"><path fill="#8e1395" fill-rule="evenodd" d="M24.707 38.101L4.908 57.899c-4.686 4.686-4.686 12.284 0 16.971L185.607 256 4.908 437.13c-4.686 4.686-4.686 12.284 0 16.971L24.707 473.9c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L41.678 38.101c-4.687-4.687-12.285-4.687-16.971 0z"/></svg>
  `);

  $('.facetwp-page.next').html(`
    <svg width="8" height="12" viewBox="0 0 256 512" xmlns="http://www.w3.org/2000/svg"><path fill="#8e1395" fill-rule="evenodd" d="M24.707 38.101L4.908 57.899c-4.686 4.686-4.686 12.284 0 16.971L185.607 256 4.908 437.13c-4.686 4.686-4.686 12.284 0 16.971L24.707 473.9c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L41.678 38.101c-4.687-4.687-12.285-4.687-16.971 0z"/></svg>
  `);
}

(function() {
  let counter = 1;
  let storyButton = document.querySelector('.StoriesHubListing-toggle');
  if (storyButton) {
    let storyToggle = new ExpandToggle(storyButton);

    $(document).on('facetwp-loaded', function() {
      // Update the height of the accordion window when we add more stories
      if (storyButton) {
        storyToggle.updateExpandedHeight();
      }

      // Disables Load More button for the StoriesHubListing Pager once we have loaded all the content to prevent duplicates from appearing.
      if (FWP.settings.pager.total_pages > counter) {
        counter += 1;
      }

      if (counter >= FWP.settings.pager.total_pages ) {
        let loadMoreButton = document.querySelector('.facetwp-load-more.StoriesHubListing-pager');
        loadMoreButton.disabled = true;
      }
    });
  }
})();
